import { toast } from 'react-toastify';

import { MODAL_KEYS } from '_constants/modals';
import { showModal } from '_store/modals/slice';
import { resetModals } from '_store/modals/slice';
import { selectLoggedIn } from '_store/user/selector';
import { logout } from '_store/user/slice';

export const authorizationCheckMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const { type, payload } = action;
    const loggedIn = selectLoggedIn(getState());

    if (type.includes('rejected') && loggedIn) {
      if (payload?.code === 401 || payload?.code === 403) {
        if (payload?.message?.includes('Accounting authentication failed')) {
          dispatch(showModal({ key: MODAL_KEYS.xeroAuthConfirm }));
        } else {
          dispatch(resetModals());
          dispatch(logout());
        }
      }
    }

    return next(action);
  };

export const notificationSystemMiddleware = () => (next) => (action) => {
  const { type, payload } = action;
  if (type.includes('rejected') && payload?.message !== 'canceled') {
    if (type === 'user/setPassword/rejected' && payload?.code === 403) {
      payload.message = 'Password has been already created or the reset code has expired.';
      toast.error(payload?.message);
    } else {
      toast.error(payload?.message || 'Something went wrong');
    }
  }

  return next(action);
};
